<template>
    <div
        class="nav-bar"
        style="background-color: white"
    >
        <!-- <b-button @click="createTestLALAMOVE">createTestLALAMOVE</b-button>
        <b-button @click="viewOrder">viewOrder</b-button> -->
        <!-- <b-tabs v-model="activeTab">
            <b-tab-item
                v-for="(status,index) in nameTab"
                :key="index"
                :label="status"
            >
                <div v-if="orderList[`${status}`] && !isLoading">
                    <div class="title">
                        <p>{{status}} ({{ orderList[`${status}`].length }})</p>
                        <p>{{ date }}</p>
                    </div>
                    <div
                        v-for="item in orderList[`${status}`]"
                        :key="item.id"
                    >
                        <CardLalamove
                            :key="item.id"
                            :villaID="item.villaOrderID"
                            :lalamoveID="item.id"
                            :status="item.status"
                            :info="item.order"
                            :date="item.deliveryDate"
                            @click.stop="onClickDebug(item)"
                        >
                        </CardLalamove>
                    </div>
                </div>
            </b-tab-item>
        </b-tabs> -->
        <div
            v-for="status,index in orderList"
            :key="index"
        >
            <div
                v-for="item in status"
                :key="item.id"
            >
                <card-lalamove
                    class="lalamove-card-style"
                    :lalamoveID="item.id"
                    :villaID="item.villaOrderID"
                    :status="item.status"
                    :shareLink="item.shareLink"
                    :updatedAt="item.updatedAt"
                />
                <!-- <div>
                    lalamove {{item.id}}
                    villa {{item.villaOrderID}}
                    status {{item.status}}
                </div> -->
            </div>
        </div>
    </div>
</template>


<script>
// ASSIGNING_DRIVER
// ON_GOING
// PICKED_UP
// COMPLETED
// EXPIRED
// CANCELED
// REJECTED
import dayjs from "dayjs";
// import { UpdateVillaOrder } from "../settings/test";
export default {
  name: "LalamoveOrder",
  components: {
    CardLalamove: () => import("@/components/CardLalamove"),
  },
  data() {
    return {
      msg: "LALAMOVE",
      date: dayjs().subtract(7, "hour").format("YYYY-MM-DD"),
      isLoading: true,
      activeTab: 0,
      nameTab: ["ASSIGNING_DRIVER", "ON_GOING", "PICKED_UP"],
    };
  },
  async mounted() {
    console.log("Hi lalamove");
    this.$store.commit("lalamove/setEmptyOrders");
    await this.getOrderTaskWaiting();
    // console.log("test", await UpdateVillaOrder("111610106235"));
  },
  computed: {
    orderList() {
      return this.$store.getters["lalamove/orders"];
    },
    msgUpdateOrderStatus() {
      return this.$store.getters["lalamove/updateLalamoveOrderStatus"];
    },
  },
  watch: {
    // orderList() {
    //   console.log("orderListorderListorderList", this.orderList);
    // },
    async msgUpdateOrderStatus() {
      this.$buefy.notification.open({
        message: `LALAMOVE ${this.msgUpdateOrderStatus.msg} ORDER ID ${this.msgUpdateOrderStatus.villaOrderID} STATUS ${this.msgUpdateOrderStatus.status}`,
        type: "is-success",
        duration: 5000,
        queue: false,
      });
    },
    // activeTab() {
    //   this.getOrderTaskWaiting();
    // },
  },
  methods: {
    onClickDebug(item) {
      console.log(item);
    },
    async getOrderTaskWaiting() {
      this.isLoading = true;
      // await this.$store.dispatch("lalamove/getLalamoveOrders", {
      //   date: this.date,
      //   status: this.nameStatus[this.activeTab],
      // });
      await Promise.all([
        this.$store.dispatch("lalamove/getLalamoveOrders", {
          date: this.date,
          status: "CREATELALAMOVE",
        }),
        this.$store.dispatch("lalamove/getLalamoveOrders", {
          date: this.date,
          status: "ASSIGNING_DRIVER",
        }),
        this.$store.dispatch("lalamove/getLalamoveOrders", {
          date: this.date,
          status: "ON_GOING",
        }),
        this.$store.dispatch("lalamove/getLalamoveOrders", {
          date: this.date,
          status: "PICKED_UP",
        }),
      ]);
      this.isLoading = false;
    },
    ManualRemoveOrder() {
      this.$store.commit("lalamove/removeTrackingOrderStatus", {
        id: "22",
        status: "COMPLETE",
        previousStatus: "C",
      });
    },
    ManualChangeStatusOrder() {
      this.$store.commit("lalamove/setSingleTrackingLalamoveOrder", {
        id: "22",
        status: "C",
        previousStatus: "A",
      });
      this.$store.commit("lalamove/removeTrackingOrderStatus", {
        id: "22",
        status: "C",
        previousStatus: "A",
      });
    },
    async getOrdersASSIGNING_DRIVER() {
      await this.$store.dispatch("lalamove/getLalamoveOrders", {
        date: this.date,
        status: "ASSIGNING_DRIVER",
      });
    },
    async getOrdersB() {
      await this.$store.dispatch("lalamove/getLalamoveOrders", { date: this.date, status: "B" });
    },
    async viewOrder() {
      console.log("Orders", this.orderList);
    },
    async createTestLALAMOVE() {
      const order = {
        origin: "Sukhumvit 33",
        originAddress: "595 ถนนสุขุมวิท แขวงคลองตันเหนือ เขตวัฒนา", //getAddressBranchs(name)
        originLocation: { lat: "13.73204799", lng: "100.56762289" }, //getLatlngBranchs(name) Map.vue
        destinationLocation: { lat: "13.723059", lng: "100.530605" },
        destinationAddress:
          "Sathorn Thani, 92/12-13 2 ถนน สาทรเหนือ แขวง สีลม เขตบางรัก กรุงเทพมหานคร 10500",
        name: "No.1",
        phone: "+66092344758",
        remark: "",
        date: dayjs().format("YYYY-MM-DDTHH:MM:ss"),
      };
      await this.$store.dispatch("lalamove/getQuotation", order);
    },
  },
};
</script>

<style  scoped>
.title {
  z-index: 10;
  font-size: 15px;
  padding: 10px;
  margin: 0;
  position: sticky;
  top: 0px;
  background-color: white;
  display: flex;
  justify-content: space-between;
}

.lalamove-card-style {
  margin: 10px;
}
</style>
